import api from 'api';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'components/modal';
import moment from 'moment';
import { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { actions } from 'redux/reducers';
import { BoardType } from 'types';
import './new-item-modal.scss';

function NewItemModal({...props}) {
    const params: any = useParams();
    const dispatch = useDispatch();
    const [boards, setBoards] = useState<BoardType[]>([]);
    const [typeId, setTypeId] = useState(2);
    const [boardId, setBoardId] = useState(0);
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [dueDate, setDueDate] = useState(new Date());
    const [shared, setShared] = useState(false);
    const [loading, setLoading] = useState(false);

    const addItem = () => {
        if (title === "") { toast.warning("Please add a title"); return; }
        if (description === "") { toast.warning("Please add a description"); return; }

        setLoading(true);
        if (typeId === 1) {
            if (boardId === 0) { toast.warning("Please select a board"); return; }

            props.setOpen(false);
            api.ticket.add(params.clientId, boardId, title, description, moment(dueDate).format("DD MMM YYYY"), 0).then(() => {
                setBoardId(0);
                setLoading(false);
                setTitle("");
                setDescription("");
                setShared(false);
                setTypeId(1);
                setDueDate(new Date());
                getData();
            })
        } else {
            props.setOpen(false);
            api.calendar.event.add(params.clientId, title, description, dueDate, shared).then(() => {
                setBoardId(0);
                setLoading(false);
                setTitle("");
                setDescription("");
                setShared(false);
                setTypeId(1);
                setDueDate(new Date());
                getData();
            })
        }
    }

    const getData = useCallback(() => {
        const monthStart = moment(props.date).startOf("M")
        const monthEnd = moment(props.date).endOf("M")
        const startDate = moment(monthStart).startOf("W")
        const endDate = moment(monthEnd).endOf("W")
        let array: any = []

        api.calendar.getAll(params.clientId, new Date(monthStart.toString()), new Date(monthEnd.add(1, "d").toString())).then((data) => {
          for (let i = startDate; i.isBefore(endDate); i.add(1, "d")) {
            const events = data.Events.filter((x: any) => moment(x.DueDate).format("DD MMM YYYY") === i.format("DD MMM YYYY")).map((x: any) => {
              return {
                ...x,
                Type: "Event",
              }
            })
            const tickets = data.Tickets.filter((x: any) => moment(x.DueDate).format("DD MMM YYYY") === i.format("DD MMM YYYY")).map((x: any) => {
              return {
                ...x,
                Type: "Ticket",
                IsShared: true
              }
            })

            array.push({
              key: i.toString(),
              data: events.concat(tickets),
            })
          }
          dispatch(actions.calendar.set(array));
        })
      }, [props.date, params.clientId, dispatch])

    useEffect(() => {
        api.board.getAll(params.clientId).then(setBoards);
    }, [params.clientId])

    useEffect(() => {
        setDueDate(new Date(new Date(props.date).setDate(props.day)));
    }, [props.day, props.date])

    return (
        <Modal open={props.open} setOpen={props.setOpen} id={props.id}>
            <ModalHeader>
                New Item
            </ModalHeader>
            <ModalBody>
                <div className="input-group">
                    <label>Type</label>
                    <input
                        type="radio"
                        className="radio"
                        id="radio-new-item-event"
                        checked={typeId === 2}
                        name="radio-new-item"
                        onChange={() => setTypeId(2)}
                    />
                    <label htmlFor="radio-new-item-event" className="radio">Event</label>
                    <input
                        type="radio"
                        className="radio"
                        id="radio-new-item-ticket"
                        checked={typeId === 1}
                        name="radio-new-item"
                        onChange={() => setTypeId(1)}
                    />
                    <label htmlFor="radio-new-item-ticket" className="radio">Ticket</label>
                </div>
                <div className="input-group boards" style={{ display: typeId === 1 ? "block" : "none" }}>
                <label>Board</label>
                    {boards.map((x, i) => (
                        <div key={i}>
                            <input
                                type="radio"
                                name="radio-new-item-board"
                                id={`check-new-item-board-${x.Board.Id}`}
                                value={x.Board.Id}
                                onChange={(e) =>setBoardId(parseInt(e.currentTarget.value))}
                            />
                            <label htmlFor={`check-new-item-board-${x.Board.Id}`}>{x.Board.Description}</label>
                        </div>
                    ))}
                </div>
                <div className="input-group">
                    <label>Title</label>
                    <input type="text" placeholder="Title" value={title} onChange={(e) => setTitle(e.currentTarget.value)} />
                </div>
                <div className="input-group">
                    <label>
                        Description <span>(optional)</span>
                    </label>
                    <textarea placeholder="Description" value={description} onChange={(e) => setDescription(e.currentTarget.value)}></textarea>
                </div>
                <div className="input-group">
                    <label>
                        Due Date <span>(optional)</span>
                    </label>
                    <input
                        type="date"
                        value={moment(dueDate).format("YYYY-MM-DD")}
                        onChange={(e) => setDueDate(new Date(e.currentTarget.value))}
                    />
                </div>
                <div className="input-group shared" style={{ display: typeId === 1 ? "none" : "block" }}>
                    <input
                        type="checkbox"
                        id="calendar-event-shared"
                        checked={shared}
                        onChange={() => setShared(!shared)}
                    />
                    <label htmlFor="calendar-event-shared">Shared</label>
                </div>
            </ModalBody>
            <ModalFooter>
                <div className="button-group">
                    <button onClick={() => props.setOpen(false)}>Cancel</button>
                    <button className="btn-primary" onClick={addItem}>
                        {loading ? <i className="fal fa-spinner fa-spin"></i> : "Save"}
                    </button>
                </div>
            </ModalFooter>
        </Modal>
    )
}

export default NewItemModal;